<div class="form-group">
  <label class="custom-form-label" for="dateRangeInput">{{'title.date-range' | translate}}</label>
  <button type="button" class="btn btn-outline-secondary w-100" id="dateRangeInput" (click)="openModal()">
    <div *ngIf="dateRange != dateRangeEnum.CUSTOM">
      {{ dateTitle }} <i class="fa fas fa-calendar"></i>
    </div>

    <div *ngIf="dateRange == dateRangeEnum.CUSTOM">
      {{ startDate | date: dateFormatEnum.DATE_FORMAT_DISPLAY }} -
      {{ endDate | date: dateFormatEnum.DATE_FORMAT_DISPLAY }} <i class="fa fas fa-calendar"></i>
    </div>
  </button>
</div>